import { createFieldSchemaRegistry } from './create-field-schema-registry';
import schemaEntries from './schemas';

export const fieldSchemaRegistry = createFieldSchemaRegistry(schemaEntries);
